import ToolTipModal from './ToolTipModal';

export default ToolTipModal;
